/**
 * Dependent credit amounts shown on the Children and Other dependents screens
 * (Form W-4, 2026, Step 3). Display only: the total stored on the W-4 is worked
 * out by the server from the two counts (`modules/onboarding/rules/w4Credits.js`),
 * so keep the two in step when a new tax year changes the amounts.
 */

export const CHILD_CREDIT = 2200;
export const OTHER_DEPENDENT_CREDIT = 500;
export const MAX_DEPENDENTS = 20;

export const totalCredits = ({ qualifyingChildren, otherDependents } = {}) =>
  (Number(qualifyingChildren) || 0) * CHILD_CREDIT + (Number(otherDependents) || 0) * OTHER_DEPENDENT_CREDIT;

export const money = (n) => `$${Number(n || 0).toLocaleString('en-US')}`;
